import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Auth from './Auth';
import Constructionlist from "./components/pages/Constructionlist";
import Inspectionlist from "./components/pages/Inspectionlist";
import InspectionlistEdit from "./components/pages/InspectionlistEdit";
import ConstructionCreat from "./components/pages/ConstructionCreat";
import login from "./components/pages/login";
import SendResetCode from "./components/pages/SendResetCode";
import PasswordReset from "./components/pages/PasswordReset";
import PasswordResetComplete from "./components/pages/PasswordResetComplete";
import loginCheck from "./components/pages/loginCheck";
import Logout from './components/pages/Logout';
import Barpage from './components/pages/bar';
import InspectionCreat from './components/pages/InspectionCreat';
import InspectionEdit from './components/pages/Inspectionedit';
import Inspectiondetail from './components/pages/Inspectiondetail';
import Insoutput from './components/pages/Insoutput';
import Userlist from "./components/pages/Userlist";
import UserCreate from "./components/pages/UserCreate";
import UserDetail from "./components/pages/UserDetail";
import UserEdit from "./components/pages/UserEdit";
import UserEditPassword from "./components/pages/UserEditPassword";
import Checklist from "./components/pages/Checklist";
import CheckCreat from "./components/pages/CheckCreat";
import CheckDatail from "./components/pages/CheckDatail";
import CheckEdit from "./components/pages/CheckEdit";
import Corporatelist from "./components/pages/Corporatelist";
import CorporateCreate from "./components/pages/CorporateCreate";
import CorporateDetail from "./components/pages/CorporateDetail";
import CorporateEdit from "./components/pages/CorporateEdit";
import Corporate from "./components/pages/Corporate";
import Test from "./components/pages/test";
import InspectionEnd from "./components/pages/InspectionEnd";
import LoadingOverlay from "./components/utilComponent/LoadingOverlay";
import BlackBoardCreate from './components/pages/BlackBoardCreate'


const App: React.FC = () => {
  return (
    <Router>

      <Switch>
        <Route path="/login" component={login} exact />
        <Route path="/SendResetCode" component={SendResetCode} exact />
        <Route path="/PasswordReset" component={PasswordReset} exact />
        <Route path="/passwordResetComplete" component={PasswordResetComplete} exact />
        <Route path="/loginCheck" component={loginCheck} exact />
        <Route path="/bar" component={Barpage} exact />
        <Route path="/InspectionEnd" component={InspectionEnd} exact />
        <Auth>
          <Switch>
            <Route exact path="/logout" component={Logout} />
            <Route path="/Constructionlist" component={Constructionlist} exact />
            <Route path="/ConstructionCreat" component={ConstructionCreat} exact />
            <Route path="/InspectionCreat" component={InspectionCreat} exact />
            <Route path="/InspectionEdit" component={InspectionEdit} exact />
            <Route path="/Inspectionlist" component={Inspectionlist} exact />
            <Route path="/InspectionlistEdit" component={InspectionlistEdit} exact />
            <Route path="/Inspectiondetail" component={Inspectiondetail} exact />
            <Route path="/Insoutput" component={Insoutput} exact />
            <Route path="/Userlist" component={Userlist} exact />
            <Route path="/UserCreate" component={UserCreate} exact />
            <Route path="/UserDetail" component={UserDetail} exact />
            <Route path="/UserEdit" component={UserEdit} exact />
            <Route path="/UserEditPassword" component={UserEditPassword} exact />
            <Route path="/Checklist" component={Checklist} exact />
            <Route path="/CheckCreat" component={CheckCreat} exact />
            <Route path="/CheckDatail" component={CheckDatail} exact />
            <Route path="/CheckEdit" component={CheckEdit} exact />
            <Route path="/Corporatelist" component={Corporatelist} exact />
            <Route path="/CorporateCreate" component={CorporateCreate} exact />
            <Route path="/CorporateDetail" component={CorporateDetail} exact />
            <Route path="/CorporateEdit" component={CorporateEdit} exact />
            <Route path="/Corporate" component={Corporate} exact />
            <Route path="/BlackBoardCreate" component={BlackBoardCreate} exact />
            <Route path="/Test" component={Test} exact />
            <Redirect from="/" to="/Constructionlist" />
          </Switch>
        </Auth>

      </Switch>
      <LoadingOverlay />
    </Router>
  );
};

export default App;